import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./styles.scss";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-10_WEB.jpg";
function SectionSix({ placeholderSrc }) {
  return (
    <div>
      <div className="tw-spacer tw-h-[6rem]"></div>
      <div className="tw-grid xl:tw-grid-cols-[95%_5%]">
        <div className="tw-grid xl:tw-grid-cols-1">
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[50%_50%]">
            <div className="tw-relative">
              <LazyLoadImage
                alt="Cubism3"
                src={photo}
                placeholderSrc={placeholderSrc}
                className="relative z-1"
              />
              <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] tw-block">
                6
              </div>
            </div>
            <div className="tw-px-4 tw-flex tw-items-center tw-flex-col tw-justify-center">
              <div className="tw-grid tw-grid-cols-1">
                <div className="tw-mt-8 borderLeftMobile">
                  <p className="tw-font-bold tw-italic tw-mb-4 tw-text-2xl">
                  Cubism<sup>3</sup>
                  </p>
                  <p>
                  This weighty, abstract piece evokes a greater sense of gravity than many of the more delicate works on the Art Walk do. A central spike points skyward, bringing to mind the point of a compass or the hand of a sundial, tools to help track the calendar and our movement through life, both poignant symbols of life in an academic setting.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionSix;
